var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"ytplayer","type":"text/html","width":"100%","src":'https://www.youtube.com/embed/'+_vm.videoId+'?rel=0&autoplay=1',"frameborder":"0","title":_vm.title,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }